import React, { useMemo } from 'react';
import * as R from 'ramda';
import { DatePickerField } from 'Shared/form/DatePickerField';
import { useFormikContext } from 'formik';
import { Col, Row } from 'react-bootstrap';
import SelectField from 'Shared/form/SelectField';
import { BI_STATUS_TYPE } from '../../PriorAuthorization/constant';
import CustomMenuField from 'Shared/form/CustomMenu';
import { TextareaField } from 'Shared/form/TextareaField';
import { NumberField } from 'Shared/form/NumberField';
import CommonPatientFieldWrapper from 'App/components/PatientForm/components/CommonPatientFieldWrapper';

const InformationForm = () => {
    const { values } = useFormikContext();
    const disableInputs = !!values.disableInputs;

    const statusOptions = useMemo(() => {
        const isStatusDeleted = values?.status?.id === BI_STATUS_TYPE.DELETED;

        const defaultStatusOptions = Object.values(BI_STATUS_TYPE).map((it) => ({
            id: it,
            name: it,
        }));
        if (!isStatusDeleted) {
            return defaultStatusOptions.filter((it) => it.id !== BI_STATUS_TYPE.DELETED);
        }
        return defaultStatusOptions;
    }, [values?.status?.id]);

    return (
        <>
            <Row>
                <CommonPatientFieldWrapper fieldName="referralBiStartDate">
                    {(commonProps) => (
                        <Col md={3}>
                            <DatePickerField
                                {...commonProps}
                                fieldName="createdOn"
                                label="Start Date"
                                disabled={commonProps.disabled || disableInputs}
                            />
                        </Col>
                    )}
                </CommonPatientFieldWrapper>
                <CommonPatientFieldWrapper fieldName="referralBiDueDate">
                    {(commonProps) => (
                        <Col md={3}>
                            <DatePickerField
                                {...commonProps}
                                id="activity-due-on"
                                fieldName="dueOn"
                                label="Due Date"
                                disabled={commonProps.disabled || disableInputs}
                            />
                        </Col>
                    )}
                </CommonPatientFieldWrapper>
                <CommonPatientFieldWrapper fieldName="referralBiCompleteDate">
                    {(commonProps) => (
                        <Col md={3}>
                            <DatePickerField
                                {...commonProps}
                                fieldName="details.completeDate"
                                label="Complete Date"
                                disabled={commonProps.disabled || disableInputs}
                            />
                        </Col>
                    )}
                </CommonPatientFieldWrapper>
                <CommonPatientFieldWrapper fieldName="referralBiPatientTotalResponsibility">
                    {(commonProps) => (
                        <Col md={3}>
                            <NumberField
                                {...commonProps}
                                fieldName="details.patientTotalResponsibilityAmount"
                                disabled={commonProps.disabled || disableInputs}
                                label="Patient Total Responsibility"
                                placeholder="Patient Total Responsibility"
                                min={0}
                                prefixAddon="$"
                            />
                        </Col>
                    )}
                </CommonPatientFieldWrapper>
            </Row>
            <Row>
                <Col md={3}>
                    <SelectField
                        inputId="status"
                        options={statusOptions}
                        label="Status"
                        fieldName="status"
                        isDisabled={disableInputs}
                        getOptionValue={R.prop('id')}
                        getOptionLabel={R.prop('name')}
                    />
                </Col>
                <CommonPatientFieldWrapper fieldName="referralBiStatusReason">
                    {(commonProps) => (
                        <Col md={3}>
                            <CustomMenuField
                                {...commonProps}
                                fieldName="details.reasonCode"
                                isDisabled={commonProps.disabled || disableInputs}
                                label="Status Reason"
                                menuName="referral_BI_Activity_Reason"
                            />
                        </Col>
                    )}
                </CommonPatientFieldWrapper>
                <CommonPatientFieldWrapper fieldName="referralBiInitialMedicationSiteOfCare">
                    {(commonProps) => (
                        <Col md={3}>
                            <CustomMenuField
                                {...commonProps}
                                fieldName="details.initialMedSiteOfCare"
                                isDisabled={commonProps.disabled || disableInputs}
                                label="Initial Medication Site Of Care"
                                menuName="referral_BI_Initial_Site_of_Care"
                            />
                        </Col>
                    )}
                </CommonPatientFieldWrapper>
            </Row>
            <Row>
                <CommonPatientFieldWrapper fieldName="referralBiNotes">
                    {(commonProps) => (
                        <Col md={12}>
                            <TextareaField
                                {...commonProps}
                                fieldName="details.notes"
                                label={`Notes (${values.details?.notes?.length || 0}/255)`}
                                placeholder="Notes"
                                disabled={commonProps.disabled || disableInputs}
                                rows={3}
                            />
                        </Col>
                    )}
                </CommonPatientFieldWrapper>
            </Row>
        </>
    );
};
export default InformationForm;
